import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_PENDING_RELEASES](state, data) {
    state.allPendingReleases = data
  },
}
